import React, {useCallback, useEffect, useRef} from 'react';
import {useRouter} from "next/navigation";
import {useBrandFilter} from '@/hook/useBrandFilter';
import SearchInput from './SearchInput';
import BrandList from "@/components/ui/sidebar/filter-sidebar/brand-filter/brand-list";


const BrandListFilter: React.FC = () => {
    const router = useRouter();
    const observer = useRef<IntersectionObserver | null>(null);

    const {
        brands,
        searchTerm,
        selectedBrands,
        loading,
        hasMore,
        handleSearchChange,
        handleBrandSelect,
        loadMore
    } = useBrandFilter();

    const lastBrandElementRef = useCallback(
        (node: HTMLDivElement) => {
            if (loading) return;
            if (observer.current) observer.current.disconnect();
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMore) {
                    loadMore();
                }
            });
            if (node) observer.current.observe(node);
        },
        [loading, hasMore, loadMore]
    );

    useEffect(() => {
        // Update URL without removing other filters
        const queryParams = new URLSearchParams(window.location.search);
        if (selectedBrands.length > 0) {
            queryParams.set('brands[]', selectedBrands.join(","));
        } else {
            queryParams.delete('brands[]');
        }
        router.push(`?${queryParams?.toString()}`);
    }, [selectedBrands, router]);

    useEffect(() => {
        const currentObserver = observer.current;
        return () => {
            if (currentObserver) {
                currentObserver.disconnect();
            }
        };
    }, []);

    return (
        <div className="mb-4">
            <SearchInput value={searchTerm} onChange={handleSearchChange}/>
            <BrandList brands={brands} lastBrandElementRef={lastBrandElementRef} handleBrandSelect={handleBrandSelect}
                       selectedBrands={selectedBrands} loading={loading}/>
        </div>
    );
};

export default BrandListFilter;
